/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, object, bool, number,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid, Typography,
} from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { uid } from 'react-uid';
import { useSelector } from 'react-redux';
import CYOItem from './CYOItem';
import { getFeatureFlag } from '../../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
    cyoGroup: {
        margin: 'auto',
        width: '100%',
        padding: `${spacing(3)}px ${spacing(2)}px`,
        [breakpoints.down('md')]: {
            maxWidth: '770px',
            width: 'min(770px, 100%)',
            padding: `${spacing(3)}px ${spacing(1)}px`,
        },
    },
    yourSelectionsTitle: {
        paddingBottom: '10px',
        fontSize: '24px',
    },
    titleContainer: (disabled) => ({
        maxWidth: 'fit-content',
        opacity: disabled ? 0.7 : 1,
    }),
    title: {
        fontSize: '18px',
        fontWeight: 600,
        marginLeft: spacing(2),
    },
    itemsContainer: {
        justifyContent: 'left',
    },
}));

const CYOGroup = React.forwardRef(({
    groupData,
    handleItemSelection,
    selectedItems,
    selectionError,
    clearError,
    handleDisabledInteraction,
    removeItem,
    disabled,
    showYourSelection,
    selectionNumber,
}, ref) => {
    const classes = useStyles(disabled);
    const cyoChooseCountShow = useSelector(getFeatureFlag('is-cyo-item-section-count-enabled'));
    return (
        <div
            className={classes.cyoGroup}
            xs={12}
            item
            ref={ref}
            container
            spacing={0}
        >
            <div className={classes.titleContainer}>
                {showYourSelection && selectionNumber
                && (
                    <Typography variant="subtitle1" className={classes.yourSelectionsTitle}>
                        {`Your Selections - Choose ${selectionNumber}`}
                    </Typography>
                )}
                <div>
                    <Typography variant="subtitle1" className={classes.title}>
                        {ReactHtmlParser(groupData.name)} {groupData?.minimumUnitsRequiredForComponent > 0 ? '- Required' : ''} {(!!(groupData?.numberofUnitsRequiredForComponent) && cyoChooseCountShow) && `- Choose ${groupData?.numberofUnitsRequiredForComponent}`}
                    </Typography>
                </div>
            </div>
            <Grid container className={classes.itemsContainer}>
                {groupData.components.map((component) => (
                    <CYOItem
                        key={uid(component.id)}
                        error={selectionError[component.legacyId]}
                        clearError={clearError}
                        handleDisabledInteraction={handleDisabledInteraction}
                        numberSelected={selectedItems[component.legacyId]?.quantity || 0}
                        handleItemSelection={(increment) => handleItemSelection(groupData, component.legacyId, component.id, increment)}
                        itemData={component}
                        removeItem={(itemID) => removeItem(groupData, itemID)}
                        disabled={disabled}
                    />
                ))}
            </Grid>
        </div>
    );
});

CYOGroup.propTypes = {
    groupData: object.isRequired,
    selectedItems: object.isRequired,
    handleItemSelection: func.isRequired,
    selectionError: object.isRequired,
    clearError: func.isRequired,
    handleDisabledInteraction: func.isRequired,
    removeItem: func.isRequired,
    showYourSelection: bool,
    selectionNumber: number,
    disabled: bool,
};

CYOGroup.defaultProps = {
    showYourSelection: false,
    selectionNumber: 0,
    disabled: false,
};

export default CYOGroup;
